/* MUVA — colour swatches on product cards for colours split across products.

   Each swatch is a link to its own product page. Clicking one swaps the card
   over to that colour (image, title, card link) instead of navigating, so the
   shopper can compare colours without leaving the listing. The card's own
   link-overlay then takes them to whichever colour is showing. */
(function () {
  const WIDTHS = [360, 540, 720, 990, 1200, 1600, 2000];

  const srcsetFor = (url) =>
    WIDTHS.map((w) => `${withWidth(url, w)} ${w}w`).join(', ');

  function withWidth(url, w) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function swapImage(img, url) {
    if (!img || !url) return;
    img.removeAttribute('sizes');
    img.srcset = srcsetFor(url);
    img.src = withWidth(url, 990);
  }

  function activate(swatch) {
    const card = swatch.closest('product-card') || swatch.closest('.product-card');
    if (!card) return;

    const row = swatch.parentElement;
    row.querySelectorAll('[data-linked-swatch]').forEach((s) => {
      s.classList.toggle('is-active', s === swatch);
      if (s === swatch) s.setAttribute('aria-current', 'true');
      else s.removeAttribute('aria-current');
    });

    const media = card.querySelector('.product-card__media');
    if (media) {
      const imgs = media.querySelectorAll('img');
      swapImage(imgs[0], swatch.dataset.lpImage);
      const second = swatch.dataset.lpImageSecondary;
      if (imgs[1]) {
        if (second) {
          swapImage(imgs[1], second);
          imgs[1].style.removeProperty('display');
        } else {
          /* No second shot for this colour — hiding it beats showing the
             hover image of a different colour. */
          imgs[1].style.display = 'none';
        }
      }
    }

    const title = card.querySelector('.product-card__title');
    if (title && swatch.dataset.lpTitle) title.textContent = swatch.dataset.lpTitle;

    const overlay = card.querySelector('.product-card__link-overlay');
    if (overlay) overlay.setAttribute('href', swatch.getAttribute('href'));
  }

  document.addEventListener('click', (e) => {
    const swatch = e.target.closest && e.target.closest('[data-linked-swatch]');
    if (!swatch) return;
    /* Let modified clicks (new tab, download…) behave like a normal link. */
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    activate(swatch);
  });
})();
